export var invert = function (check) { return function (path) {
    return function (action, state$, deps) {
        return check(path)(action, state$, deps) ? undefined : path;
    };
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/guards/invert.ts
// module id = 356
// module chunks = 3